export const facebookKeys = {
  facebook_analytics: (videoId: number) => ['FACEBOOK_ANALYTICS', videoId], // get facebook video analytics
  facebook_integration_status: () => ['FACEBOOK_INTEGRATION_STATUS'],
};
